import { ReactNode } from 'react';
import styled from 'styled-components';

interface IInfoWrapperBoxProps {
    className?: string;
    children: ReactNode;
}

const InfoWrapper = ({ className, children }: IInfoWrapperBoxProps) => {
    return <div className={className}>{children}</div>;
};

const Styled = styled(InfoWrapper)`
    & > div {
        display: flex;
        align-items: center;
        margin-bottom: 2rem;
        & > span:first-of-type,
        & > svg {
            margin-right: 1rem;
        }
    }
`;

export default Styled;
